import React, { useState, useEffect } from "react";
import styles from "./TradedStocks.module.css";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

const TradedStocks = () => {
  const [stocks, setStocks] = useState([]); // Firestore에서 불러온 데이터 저장
  const navigate = useNavigate();

  // Firestore에서 회사 목록 불러오기
  useEffect(() => {
    const fetchStocks = async () => {
      try {
        const q = query(
          collection(db, "companies"),
          orderBy("createdAt", "asc")
        ); // 최신순 정렬
        const querySnapshot = await getDocs(q);
        const stockList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setStocks(stockList);
      } catch (error) {
        console.error("회사 데이터 불러오기 실패:", error);
      }
    };

    fetchStocks();
  }, []);

  return (
    <section className={styles.tradedStocks}>
      <h2 className={styles.title}>Traded Stocks</h2>
      <div className={styles.stockGrid}>
        {stocks.length > 0 ? (
          stocks.map((stock) => (
            <div
              key={stock.id}
              className={styles.stockCard}
              onClick={() => navigate(`/stocks/${stock.name}/overview`)}
            >
              <img
                src={stock.logo}
                alt={stock.name}
                className={styles.stockLogo}
              />
              <h3 className={styles.stockName}>{stock.name}</h3>
            </div>
          ))
        ) : (
          <p className={styles.noData}>등록된 회사가 없습니다.</p>
        )}
      </div>
    </section>
  );
};

export default TradedStocks;
